import PropTypes from "prop-types";
import "./style.scss";

const StepButtons = ({ buttons }) => {
  return (
    <div className="step-buttons">
      {buttons.map((button) => (
        <div
          key={`${button.text}-${String(button.style)}`}
          className="step-button"
        >
          {button}
        </div>
      ))}
    </div>
  );
};

StepButtons.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      innerText: PropTypes.string,
    }),
  ).isRequired,
};

export default StepButtons;
